import { getAxiosObject } from '@/utils/library'
import {
  commonGetters,
  commonActions,
  commonMutations
} from '@/store/store_utils'

const dataName = 'species'

const state = { species: [], dataIndexedById: {}, updatedAt: '20101010101010' }

const getters = {
  ...commonGetters(
    dataName,
    [
      'getData',
      'getDataIncludeDel',
      'getDataById',
      'selectData',
      'getUpdatedAt'
    ],
    { filterDel: true }
  )
}

const actions = {
  ...commonActions(['setData', 'setUpdatedAt', 'updateAfter']),
  async create({ commit }, species) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.post('/species', { species })
      if (res.status === 200) {
        commit('updateAfter', [res.data.species])
        if (res.data.examinationSpecies?.length > 0) {
          commit(
            'examinationSpecies/updateAfter',
            res.data.examinationSpecies,
            { root: true }
          )
        }
        return true
      }
    } catch (error) {
      return error.response?.data?.message || 'server error'
    }
  },
  async delete({ commit }, id) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.delete('/species', { data: { id } })
      if (res.status === 200) {
        commit('updateAfter', [res.data.species])
        return true
      }
    } catch (error) {
      if (error.response?.data?.message) {
        if (error.response.data.extra === 'last species') {
          return error.response.data.extra
        } else {
          if (error.response.data.extra?.data) {
            commit('setData', error.response.data.extra.data)
          }
          return error.response.data.message
        }
      } else {
        return 'server error'
      }
    }
  },
  async update({ commit }, species) {
    try {
      const axiosObject = getAxiosObject()
      const res = await axiosObject.put('/species', { species })
      if (res.status === 200) {
        commit('updateAfter', [res.data.species])
        return true
      }
    } catch (error) {
      if (error.response?.data?.message) {
        if (error.response?.data?.extra?.data) {
          commit('setData', error.response.data.extra.data)
        }
        return error.response.data.message
      } else {
        return 'server error'
      }
    }
  }
}

const mutations = {
  ...commonMutations(dataName, ['setData', 'updateAfter', 'setUpdatedAt'], {
    order: true,
    indexedById: true
  })
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
